import { formatActionType } from 'app/dealer/shared/higherOrderReducers/withDataRequest/actionTypeFormatters';

import { LISTINGS_BENCHMARK_REDUCER_NAME } from '../constants';

export const ListingsBenchmarkListingsTurnoverActionTypes = {
  GET_LISTINGS_TURNOVER_DATA_SUCCESS: `[${formatActionType(
    LISTINGS_BENCHMARK_REDUCER_NAME,
  )} Listings Turnover] SUCCESS`,
  GET_LISTINGS_TURNOVER_DATA_ERROR: `[${formatActionType(
    LISTINGS_BENCHMARK_REDUCER_NAME,
  )} Listings Turnover] ERROR`,
};

// general
export const LISTINGS_TURNOVER_CACHE_PREFIX = 'listingsTurnover';
